export const considered_as_eu_em = (values, countries) => {
    const {self_reg_establishment = [], registered_country} = values;
    const {is_eu = false} = countries[`${registered_country}`] || {};

    return is_eu || self_reg_establishment.find(({country_id}) => {
        const {is_eu = false} = countries[`${country_id}`] || {}
        return is_eu;
    });
}

export function isEmpty(value){
    return value == null || value === "" || (Array.isArray(value) && value.filter(p=>(!isEmpty(p))).length === 0) || (typeof value === "object" && Object.keys(value).length === 0)
}

export const schemeTypes = Object.freeze({
    Import: 1,
    Union: 2,
    NonUnion: 3
})

export const schemeTypeIndexSubString = Object.freeze({
    Import: 'import',
    Union: 'union',
    NonUnion: 'non_union'
})

const salesTypeSchemeMapping = Object.freeze({
    sales_type_i: schemeTypes.Union,
    sales_type_ii: schemeTypes.Union,
    sales_type_iii: schemeTypes.Import,
    sales_type_iv: schemeTypes.Union,
    sales_type_v: schemeTypes.NonUnion,
    sales_type_vi: {tbe: schemeTypes.Union, non_tbe: schemeTypes.NonUnion},
    sales_type_vii: schemeTypes.Union,
    sales_type_viii: schemeTypes.Import,
    sales_type_ix: schemeTypes.Union,
    sales_type_x: {eu: schemeTypes.Union, non_eu: schemeTypes.NonUnion},
})

export const validSchemas = (data, is_eu = false) => {

    const {
        sales_type_i,
        sales_type_ii,
        sales_type_iii,
        sales_type_iv,
        sales_type_v,
        sales_type_vi,
        sales_type_vii,
        sales_type_viii,
        sales_type_ix,
        sales_type_x,
        tbe_subscription
    } = data;

    return Object.entries({
        sales_type_i,
        sales_type_ii,
        sales_type_iii,
        sales_type_iv,
        sales_type_v,
        sales_type_vi,
        sales_type_vii,
        sales_type_viii,
        sales_type_ix,
        sales_type_x
    }).filter(([, v]) => v).map(([k]) => {
        switch (k) {
            case "sales_type_x":
                return is_eu ? salesTypeSchemeMapping[k]['eu'] || schemeTypes.Union : salesTypeSchemeMapping[k]['non_eu'] || schemeTypes.NonUnion;
            case "sales_type_vi":
                return tbe_subscription ? schemeTypes.Union : schemeTypes.NonUnion
            default:
                return salesTypeSchemeMapping[k]
        }


    })
}

export const toEm = (ss_em, countries) => {
    const {
        id,
        status,
        name,
        short_name,
        tin,
        registered_address,
        registered_country,
        np_title_primary,
        np_primary,
        np_position_primary,
        np_phone_primary,
        np_email_primary,
        np_title_secondary,
        np_secondary,
        np_position_secondary,
        np_phone_secondary,
        np_email_secondary,
        ok_with_eas_filing_reports_b_c,
        reporting_portal_username,
        reporting_portal_password,
        long_distance_sales,
        vat_collected,
        moss_registered,
        moss_registry_number,
        oss_special_schema_registered,
        ss_nr_want_to_register,
        ss_nr_continue_without_oss,
        ss_nr_oss_preferred_country,
        ss_nr_fc_rep_only,
        ss_reg_ioss_import_scheme_id,
        ss_reg_ioss_import_scheme_country,
        ss_reg_ioss_import_scheme_requested,
        ss_reg_ioss_import_scheme_commenced,
        ss_reg_ioss_non_union_scheme_id,
        ss_reg_ioss_non_union_scheme_country,
        ss_reg_ioss_non_union_scheme_requested,
        ss_reg_ioss_non_union_scheme_commenced,
        ss_reg_ioss_union_scheme_id,
        ss_reg_ioss_union_scheme_requested,
        ss_reg_ioss_union_scheme_commenced,
        fixed_establishment_available,
        vat_id,
        ei,
        official_site,
        multiple_sites,
        multiple_integrations,
        setting_goods_locally,
        sales_type_i,
        sales_type_ii,
        sales_type_iii,
        sales_type_iv,
        sales_type_v,
        sales_type_vi,
        sales_type_vii,
        sales_type_viii,
        sales_type_ix,
        sales_type_x,
        sales_type,
        ss_reg_ioss_union_scheme_country,
        ei_can_identify_source,
        self_reg_establishment,
        self_reg_site,
        self_reg_warehouse_vat,
        tbe_subscription,
        other_courier,
        delayed_payment,
        checkout,
        po,
        custom_checkout,
        alternative_sales,
        promotion_code

    } = ss_em;


    const w_vat_ids = (self_reg_warehouse_vat || []).map(({id, country_id, ...args}) => ({
        ...args,
        type: 'warehouse',
        country_id
    }));
    const m_vat_ids = moss_registry_number ? [{type: "moss", vat_id: moss_registry_number}] : [];
    const fe_vat_ids = (self_reg_establishment || []).map(({vat_number, country_id}) => ({
        type: "fixed_establishment",
        vat_id: vat_number,
        country_id
    }))

    const salesTypes = Object.entries({
        "1": sales_type_i,
        "2": sales_type_ii,
        "3": sales_type_iii,
        "4": sales_type_iv,
        "5": sales_type_v,
        "6": sales_type_vi,
        "7": sales_type_vii,
        "8": sales_type_viii,
        "9": sales_type_ix,
        "10": sales_type_x
    }).filter(([, v]) => v).map(([k]) => k);

    return {
        _source: "auto",
        application_id: id,
        b2b_sales: sales_type !== 'b2c_only',
        bank_address: "",
        bank_name: "",
        bic: "",
        checkout: checkout,
        custom_checkout_name: custom_checkout,
        cn_form_signee_name: "",
        cn_form_signee_title: "",
        company_description: "",
        em_establishment: (self_reg_establishment || []).map(({id, name: q, ...args}) => ({...args, name: q || name})),
        em_site: (self_reg_site || []).map(({id, ...args}) => ({...args})),
        em_vat: [].concat(w_vat_ids, m_vat_ids, fe_vat_ids),
        fee_class: "auto",
        full_name: name,
        iban: "",
        iban_or_oban: null,
        integrate_all_sites: multiple_integrations && (self_reg_site.length || []) > 1 && (self_reg_site || []).find(o => o.integrated !== false) == null,
        ioss_import_scheme_commencement_date: ss_reg_ioss_import_scheme_commenced,
        ioss_import_scheme_registered_country: ss_reg_ioss_import_scheme_country,
        ioss_import_scheme_request_date: ss_reg_ioss_import_scheme_requested,
        ioss_registered: oss_special_schema_registered,
        ioss_registry_import_scheme_id: ss_reg_ioss_import_scheme_id,
        ioss_registry_union_scheme_id: ss_reg_ioss_union_scheme_id,
        ioss_union_scheme_commencement_date: ss_reg_ioss_union_scheme_commenced,
        ioss_union_scheme_request_date: ss_reg_ioss_union_scheme_requested,
        ioss_registry_non_union_scheme_id: ss_reg_ioss_non_union_scheme_id,
        ioss_non_union_scheme_registered_country: ss_reg_ioss_non_union_scheme_country,
        ioss_non_union_scheme_request_date: ss_reg_ioss_non_union_scheme_requested,
        ioss_non_union_scheme_commencement_date: ss_reg_ioss_non_union_scheme_commenced,
        is_taxee_electronic: ei,
        legal_status: considered_as_eu_em(ss_em, countries) ? "established_in_eu" : "not_established_in_eu",
        method_of_fulfillment: [],
        fc_representation_only: (!oss_special_schema_registered) && (!ss_nr_want_to_register) && ss_nr_continue_without_oss,
        multiple_integrations: multiple_integrations,
        multiple_sites: multiple_sites,
        nominated_email: np_email_primary,
        nominated_email_secondary: np_email_secondary,
        nominated_person: np_primary,
        nominated_person_secondary: np_secondary,
        nominated_phone_secondary: np_phone_secondary,
        nominated_position: np_position_primary,
        nominated_position_secondary: np_position_secondary,
        nominated_title: np_title_primary,
        nominated_title_secondary: np_title_secondary,
        official_site_url: official_site,
        oss_country_of_identification: ss_nr_oss_preferred_country,
        //oss_special_scheme_country:
        //payment_currency_id: 11
        //payment_handling_mode: "indirect"
        allow_deferred_payment: delayed_payment,
        phone: np_phone_primary,
        po_of_choice: po,
        //register_date_by_eas_intermediary: ""
        registered_address: registered_address,
        registered_country: registered_country,
        //request_date_by_eas_intermediary: "",
        sales_through_ei: ei,
        sales_type: salesTypes,
        tin_number: tin,
        trade_name: "",
        //type_of_goods:
        unknown_seller: ei_can_identify_source,
        unknown_warehouse: false,
        vat_eu: vat_id,
        weight_unit: "kg",
        alternative_sales: alternative_sales,
        ioss_union_scheme_registered_country: ss_reg_ioss_union_scheme_country,
        ok_with_eas_filing_reports_b_c: ok_with_eas_filing_reports_b_c,
        reporting_portal_username: reporting_portal_username,
        reporting_portal_password: reporting_portal_password,
        promotion_code: promotion_code
    }


}
